// extracted by mini-css-extract-plugin
module.exports = {"background":"background_background__yd1PI","partialSelection":"background_partialSelection__KMlI8","overlay":"background_overlay__bPyFt","video":"background_video__1i_HA"};